/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import { useNavigate, useParams, Link } from 'react-router-dom';
 
const EditUser = () => {
    const { id } = useParams();
    const [name, setName] = useState('');
    const [company, setCompany] = useState([]);
    const [role, setRole] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [msg, setMsg] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);    
    const [access, setAccess] = useState([]);
    const [canUpdateCallPassPermissions, setCanUpdateCallPassPermissions] = useState(false);
    const [applicationList, setApplicationList] = useState([]);
    const [formData, setFormData] = useState({
        user_role: '0',
        cname: '',
        fname: '',
        lname: '',
        email: '',
        officephone: '',
        mobilephone: '',
        user_pbx_switch: [],
        pbx_switch: false,
        tns_api_access: false,
        enrms_access_switch: false,
        enrms_registration_switch: false,
        enrms_registration_edit_switch: false,
        enrms_registration_admin_switch: false,
        pbx_url:null,
        pbx_username:null,
        mfa_status: false,
        pbx_password:null,
        number_management_access_switch:false,
        user_e911_switch: false,
        user_cname_switch : false,
        user_digit_mapping_switch : false,
        user_advance_digit_mapping_switch : false,
        user_report_switch : false,
        user_inventory_switch : false,
        user_multiple_inventory_switch : false,
        user_call_pass_branded_calling_switch : 0,
        user_call_pass_display_identities_switch : 0,
        user_call_pass_export_switch : 0,
        user_international_order_switch: false,
        user_manage_tags: false,
        device_management_access: 0,
        export_user_access: false,
        view_bap_id_access: false,
    });
    const [accessRight, setAccessRight] = useState({
        createuser: false,
        edituser: false,
        deleteuser: false,
        viewuser: false,
        ordernewnumber: false,
        viewtransactions: false,
        modifynumber: false,
        cancelnumber: false,
        viewinventory: false,
        callpassaccess: false,
        dolaccess: false
    });
    const [setting, setSetting] = useState({
        disconnectSwitch: false,
        disconnectday: 0,
    });
    const [trunkData, setTrunksData] = useState([]);
    const [whiteLabelData, setWhiteLabelData] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [next, setNext] = useState(false);
    const [compAccessList, setCompAccessList] = useState({
        company_e911_switch: false,
        company_cname_switch : false,
        company_digit_mapping_switch : false,
        company_advance_digit_mapping_switch : false,
        company_report_switch : false,
        company_inventory_switch : false,
        company_multiple_inventory_switch : false,
        company_call_pass_branded_calling_swtich : false,
        company_call_pass_display_identities_switch : false,
        company_international_order_switch : false
    })

    const navigate = useNavigate();
 
    useEffect(() => {
        refreshToken();
      }, []);
    useEffect(() => {
        if (token && id) {
          checAccess(id);
        }
    }, [token, id]);
    
      useEffect(() => {
        if (token && next) {
          getUserCompany();
          getUserDetail();
          getUserAccess();
        }
      }, [token && next]);
      useEffect(() => {
        if(access.length > 0 && token){
            checkAccess(access, token);
        }
        
    }, [access, token]);
      
 
    const refreshToken = async () => {
        try {
            setPopupOpen(true);
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setPopupOpen(false);
            setRole(decoded.role);
            setName(decoded.name);
            setExpire(decoded.exp);
        } catch (error) {
            
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axios.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setAccess(response.data.results);
            setCanUpdateCallPassPermissions(parseInt(response.data.user_call_pass_update_customer_permissions_switch) >= 1);
            // setIsLoading(false);
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
      };

    const handleSwitchChange = (event) => {
        const { name, checked } = event.target;
        setSetting((prevSetting) => ({
            ...prevSetting,
            [name]: checked,
        }));
    };

    const handlePBXSwitchChange = (event) => {
        const { name, checked } = event.target;
        const id = parseInt(name, 10); // Convert to number
        console.log(`name: ${name} & checked: ${checked}`);
        setFormData((prevData) => {
            // Ensure user_pbx_switch is always an array
            const currentPBXSwitch = Array.isArray(prevData.user_pbx_switch) ? prevData.user_pbx_switch : [];
    
            // If checked, add the numeric ID to the array; if unchecked, remove it
            const updatedPBXSwitch = checked
                ? [...currentPBXSwitch, id] // Add the number to the array
                : currentPBXSwitch.filter((item) => item !== id); // Remove the number from the array
    
            console.log({
                ...prevData,
                user_pbx_switch: updatedPBXSwitch,
            });
    
            return {
                ...prevData,
                user_pbx_switch: updatedPBXSwitch,
            };
        });
    };

    const handleTnsSwitchChange = (event) => {
        const { name, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
        }));
    }

    const handleMFASwitchChange = (event) => {
        const { name, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
        }));
    }

    const handleNumberManagementSwitchChange = (event) => {
        const { name, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
        }));
    }
    const handleDayChange = (event) => {
        const { name, value } = event.target;
        setSetting((prevSetting) => ({
            ...prevSetting,
            [name]: parseInt(value),
        }));
    };

    const handleCheckboxChange = (event, name, type) => {
        const isChecked = event.target.checked;
        if(type === 0){
            if (isChecked) {
                setTrunksData([...trunkData, name]);
            } else {
                setTrunksData(trunkData.filter(n => n !== name));
            }
        }else{
            if (isChecked) {
                setWhiteLabelData([...whiteLabelData, name]);
            } else {
                setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            }
        }
        
    };

    const checAccess = async(id) => {
        try {
            setPopupOpen(true);
            const response =  await axios.get(`${baseUrl}/check-access/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            // setPopupOpen(false);
            // console.log("sddsdsd");
            // console.log(response.data);
            // console.log(response.data.isAccess);
            if(!response.data.isAccess){
                setNext(false);
                navigate('/dashboard');
              
            }else{
                setNext(true);
            }
            
            // setAccess(response.data.results);
            // setIsLoading(false);
            
        } catch (error) {
            // console.log("ddsd")
            // console.log(error);
            setNext(false);
            navigate('/dashboard');
        }
        // console.log(id);
    }

    const checkAccess = async (access) => {
        if((role === 2 && !hasPermission('edituser')) || role === 5){
            navigate('/dashboard');
        }
    }
   
    const getUserCompany = async () => {
        
        const response = await axios.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        // console.log(response.data);
        setCompany(response.data);
    }

    const getUserDetail = async () => {
        try {
            setPopupOpen(true);
            const response = await axios.get(`${baseUrl}/get-user-detail/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setPopupOpen(false);
            // console.log(response.data);
            const userData = response.data.user[0];
            const companyDetailsData = response.data.company_details;
            const enrmsDetailData = response.data.enrms;
            const applicationData = response.data.applicationList;
            console.log(enrmsDetailData, "enrmsDetailData");
            console.log("companyDetailsData",companyDetailsData);
            setFormData({
                user_role: userData.role, // Convert to string if needed
                cname: userData.cid,
                fname: userData.fname,
                lname: userData.lname,
                email: userData.email,
                officephone: userData.office_phone,
                mobilephone: userData.mobile_phone,
                user_pbx_switch:JSON.parse(userData.user_pbx_switch) ?? [],
                pbx_switch: userData.pbx_switch === 1,
                tns_api_access: userData.tns_api_access === 1,
                enrms_access_switch: userData.enrms_access_switch === 1,
                enrms_registration_switch: userData.enrms_registration_switch === 1,
                enrms_registration_edit_switch: userData.enrms_registration_edit_switch === 1,
                enrms_registration_admin_switch: userData.enrms_registration_admin_switch === 1,
                pbx_url: userData.pbx_url,
                pbx_username: userData.pbx_username,
                pbx_password: userData.pbx_password,
                enable_tns_api:companyDetailsData[0]?.enable_tns_api,
                cia_enable_switch : enrmsDetailData[0]?.cia_enable_switch,
                cia_account_type : enrmsDetailData[0]?.cia_account_type,
                mfa_status: userData.mfa_status === 1,
                number_management_access_switch: userData.number_management_access_switch === 1,
                user_e911_switch: userData.user_e911_switch == 1,
                user_cname_switch :userData.user_cname_switch == 1,
                user_digit_mapping_switch :userData.user_digit_mapping_switch == 1,
                user_advance_digit_mapping_switch :userData.user_advance_digit_mapping_switch == 1,
                user_report_switch :userData.user_report_switch == 1,
                user_inventory_switch :userData.user_inventory_switch == 1,
                user_multiple_inventory_switch :userData.user_multiple_inventory_switch == 1,
                               user_call_pass_branded_calling_switch: parseInt(userData.user_call_pass_branded_calling_switch) || 0,
                user_call_pass_display_identities_switch : parseInt(userData.user_call_pass_display_identities_switch) || 0,
                user_call_pass_export_switch: parseInt(userData.user_call_pass_export_switch) === 1,
                user_call_pass_update_customer_permissions_switch: parseInt(userData.user_call_pass_update_customer_permissions_switch) === 1,
                user_international_order_switch:userData.user_international_order_switch == 1,
                user_manage_tags :userData.user_manage_tags == 1,
                device_management_access: parseInt(userData.device_management_access) || 0,
                export_user_access: userData.export_user_access == 1,
                view_bap_id_access: userData.view_bap_id_access == 1
            });
            const companyAccessList = {
                company_e911_switch: companyDetailsData[0]?.e911_switch == 1 ? true : false,
                company_cname_switch: companyDetailsData[0]?.cname_switch == 1 ? true : false,
                company_digit_mapping_switch : companyDetailsData[0]?.digit_mapping_switch == 1 ? true : false,
                company_advance_digit_mapping_switch : companyDetailsData[0]?.advance_digit_mapping_switch == 1 ? true : false,
                company_report_switch : companyDetailsData[0]?.report_switch == 1 ? true : false,
                company_inventory_switch : companyDetailsData[0]?.inventory_switch == 1 ? true : false,
                company_multiple_inventory_switch : companyDetailsData[0]?.multiple_inventory_switch == 1 ? true : false,
                company_call_pass_branded_calling_swtich : parseInt(companyDetailsData[0]?.call_pass_branded_calling_switch) || 0,
                company_international_order_switch: companyDetailsData[0]?.international_order_switch == 1 ? true : false,
                company_call_pass_display_identities_switch : parseInt(companyDetailsData[0]?.call_pass_display_identities_switch) || 0
            };
            setCompAccessList(companyAccessList)
            const userAccessData = response.data.user_access;
            

            const updatedAccessRight = { ...accessRight }; // Create a copy of the state
            
            userAccessData.forEach((access) => {
              const { access: accessName, value } = access;
              updatedAccessRight[accessName] = value === 1; // Convert value to boolean
            });
      
            setAccessRight(updatedAccessRight);
            setApplicationList(applicationData);

            //   const userSettingData = response.data.user_setting[0];
            //   if (userSettingData) {
            //     setSetting({
            //         disconnectSwitch: userSettingData.disconnect_switch === 1,
            //         disconnectday: userSettingData.disconnect_day,
            //     });
            // } 
            // console.log(setting.disconnectSwitch);

            //   const userTrunk = response.data.user_trunk;;
            //   setTrunksData(userTrunk);
            //   const userLabel = response.data.user_white_label;;
            //   setWhiteLabelData(userLabel);
            // console.log(userData);
        }catch{
            navigate('/dashboard');
        }
    };  
    const [validationErrors, setValidationErrors] = useState({
        user_role: false,
        email: false,
        cname: false,
        fname: false,
        lname: false,
        officephone: false,
        mobilephone: false

    });
    const formRef = useRef(null);
    const validateEmail = (email) => {
        if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) return false;
        if (parseInt(formData.user_role) <= 2) {
            return email.toLowerCase().endsWith('@broadbanddynamics.com');
        }
        return true;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            user_role: formData.user_role === '0',
            email: !validateEmail(formData.email),
            cname: formData.cname === '',
            fname: formData.fname === '',
            lname: formData.lname === '',
            officephone: !/^\d{1,10}$/.test(formData.officephone),
            mobilephone: !/^\d{1,10}$/.test(formData.mobilephone)


          };
          setValidationErrors(newValidationErrors);
      
          // Check if there are any validation errors
          const hasErrors = Object.values(newValidationErrors).some((error) => error);
      
          if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            // console.log(firstInvalidInput);
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          } else {
            // If no validation errors, proceed with form submission
            // console.log('Form submitted with data:', formData);
            // console.log(token);
            const rightsArray = Object.entries(accessRight).map(([key, value]) => ({
                name: key,
                value: value ? 1 : 0,
              }));
             
              const combinedData = {
                formData: formData,
                rightsArray: formData.user_role == 2 ? rightsArray : rightsArray.filter(obj => obj.name != "callpassaccess" && obj.name != "dolaccess"),
                setting :setting,
                trunks: trunkData,
                whitelabel:whiteLabelData
              };
              console.log(combinedData);
            try {
                setButtonDisabled(true);
                setPopupOpen(true);
                await axios.put(`${baseUrl}/user/edit/${id}`,combinedData,{headers: {
                    Authorization: `Bearer ${token}`
                }});
                setIsSuccess(true);
                navigate("/user");
            } catch (error) {
                setButtonDisabled(false);
                setPopupOpen(false);
                if (error.response) {
                    setIsSuccess(false);
                    setMsg(error.response.data.msg);
                }
            }
          }
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'user_role' && value <= 2) {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
                cname: '1' // Set cname to '1' if user_role is less than or equal to 2
            }));
            // setTrunksData([]);
            // setWhiteLabelData([]);
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }
    
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

      const accessRightLabels = {
        createuser: 'Create Users/Customers',
        edituser: 'Edit Users/Customers',
        deleteuser: 'Delete Users/Customers',
        viewuser: 'View Users/Customers',
        ordernewnumber: 'Order New Number Access',
        modifynumber: 'Modify Number',
        cancelnumber: 'Cancel Number',
        viewinventory: 'View Inventory',
        callpassaccess: "Call Pass Access",
        dolaccess: "DOL Access"
      };
    
 
    return (
        <div className="panelbox">
           <Navbar token={token} access={access}/>
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page admin-new-addstaff-page">
                    <div className="fullrow">
                        <div className="row">
                            <div className="col-6">
                                <div className="left-title">
                                    <h1>Edit User</h1>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="addnew-button">
                                    <Link to="/user"><span>&larr;</span> Back</Link>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                            <p className={`has-text-centered ${isSuccess ? 'success' : 'error'}`}>{msg}</p>
                                <div className="edit-staff-data-form add-new-staff-form">
                                    <form className="form-box" onSubmit={handleSubmit} ref={formRef}>
                                        <div className="common-white-shadow-background">
                                            <div className="innerboxwidth">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <h3>User Info</h3>
                                                    </div>
                                                    <div className="col-6">
                                                    <label>User Types</label>
                                                        <select name="user_role"  disabled={formData.user_role <= 2 || role >= 4} id="user_role"  value={formData.user_role} onChange={handleInputChange} className={validationErrors.user_role ? 'invalid' : ''}>
                                                            <option value="0">User Types</option>                
                                                            {role === 0 &&<option value="1">Super Admin</option>}
                                                            {formData.user_role <= 2 && role <= 2 && <option value="2">BBD Support User</option>}
                                                            {formData.user_role <= 2 && role <= 2 && <option value="3">Reseller admin user</option>}
                                                            {(role <= 3 || formData.user_role >= 4) && <option value="4">Customer admin user</option>}
                                                            {role <= 5 && <option value="5">Customer user</option>}
                                                        </select>
                                                        {validationErrors.user_role && <div className="error error-message">Please select a user role.</div>}
                                                    </div>
                                                    <div className="col-md-12">
                                                    <label>Company</label>
                                                        <select name="cname" disabled value={formData.cname} onChange={handleInputChange} className={validationErrors.cname ? 'invalid' : ''} >
                                                            <option value="">Select a company</option>
                                                            {company.map((comp, index) => (
                                                              <option key={index} value={comp.id}>
                                                                {comp.cname}
                                                              </option>
                                                            ))}
                                                        </select>
                                                        {validationErrors.cname && <div className="error error-message">Please Enter Company Name.</div>}
                                                    </div>
                                                    <div className="col-md-6">
                                                    <label>First Name</label>
                                                        <input type="text" name="fname" defaultValue={formData.fname} placeholder="First Name*" onChange={handleInputChange} className={validationErrors.fname ? 'invalid' : ''} />
                                                        {validationErrors.fname && <div className="error error-message">Please Enter First Name.</div>}
                                                    </div>
                                                    <div className="col-md-6">
                                                    <label>Last Name</label>
                                                        <input type="text" name="lname" defaultValue={formData.lname} placeholder="Last Name*"  onChange={handleInputChange} className={validationErrors.lname ? 'invalid' : ''} />
                                                        {validationErrors.lname && <div className="error error-message">Please Enter last name.</div>}
                                                    </div>
                                                    <div className="col-sm-12">
                                                    <label>Email</label>
                                                        <input type="email" name="email" disabled={(role > 2 )} defaultValue={formData.email} placeholder="Email"  onChange={handleInputChange} className={validationErrors.email ? 'invalid' : ''}/>
                                                        
                                                        {validationErrors.email && <div className="error error-message">{parseInt(formData.user_role) <= 2 ? 'BBD Support Users must use a @broadbanddynamics.com email address.' : 'Please enter a valid email address.'}</div>}
                                                    </div>

                                                    <div className="col-sm-6">
                                                    <label>Office Phone Number</label>
                                                        <input type="number" name="officephone" defaultValue={formData.officephone}
                                                            pattern="[0-9]*"  placeholder="Office Phone Number*" onChange={handleInputChange} className={validationErrors.officephone ? 'invalid' : ''} />
                                                            {validationErrors.officephone && <div className="error error-message">Phone number should not be longer than 10-digits.</div>}
                                                    </div>
                                                    <div className="col-sm-6">
                                                    <label>Mobile Phone Number</label>
                                                        <input type="number" name="mobilephone" defaultValue={formData.mobilephone}
                                                            pattern="[0-9]*"  placeholder="Mobile Phone Number*" onChange={handleInputChange} className={validationErrors.mobilephone ? 'invalid' : ''} />
                                                            {validationErrors.mobilephone && <div className="error error-message">Phone number should not be longer than 10-digits.</div>}
                                                    </div>
                                                    
                                                    {(formData.user_role == '2' || formData.user_role == '5') && <div className="col-sm-12">
                                                        <p>Access Rights</p>
                                                        <div className="checkboximage">
                                                        {/* {Object.entries(accessRight).map(([key, value]) => (
                                                            <label key={key} htmlFor={key}>
                                                            <input type="checkbox" name={key} id={key} checked={value} onChange={(e) =>
                                                                setAccessRight((prevRights) => ({
                                                                  ...prevRights,
                                                                  [key]: e.target.checked,
                                                                }))}
                                                            />
                                                            {accessRightLabels[key]}
                                                            </label>
                                                        ))} */}
                                                        {Object.entries(accessRight)
                                                        .filter(([key]) => {
                                                            if (formData.user_role == '5') {
                                                                // Editing a customer user — hide admin-only access options
                                                                return !['createuser', 'edituser', 'deleteuser', 'viewuser', 'viewtransactions', 'modifynumber', 'viewinventory', 'callpassaccess', 'dolaccess'].includes(key);
                                                            } else if (role == '1' || role == '0') {
                                                                // Super admin editing a BBD user — can set all access except unused fields
                                                                // callpassaccess is shown in Call Pass Permissions section instead
                                                                if (formData.user_role == '2') {
                                                                    return !['viewtransactions', 'modifynumber', 'callpassaccess'].includes(key);
                                                                }
                                                                return !['viewtransactions', 'modifynumber'].includes(key);
                                                            } else {
                                                                // BBD Support (role 2) editing a BBD user — cannot set DOL or Call Pass access
                                                                return !['viewtransactions', 'modifynumber', 'callpassaccess', 'dolaccess'].includes(key);
                                                            }
                                                        })
                                                        .map(([key, value]) => (
                                                            <label key={key} htmlFor={key}>
                                                            <input type="checkbox" name={key} id={key} checked={value} onChange={(e) =>
                                                                setAccessRight((prevRights) => ({
                                                                  ...prevRights,
                                                                  [key]: e.target.checked,
                                                                }))}
                                                            />
                                                            {accessRightLabels[key]}
                                                            </label>
                                                        ))}
                                                        </div>
                                                    </div>}
                                                </div>
                                            </div>
                                            {(role < 3) && <div class="row mt-10">
                                                <div className="innerboxwidth">
                                                    <div className="settingbox">
                                                        <label>MFA</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="mfaswitch" class="mt-10" className="checkbox"  checked={formData.mfa_status === true} name="mfa_status"  onChange={handleMFASwitchChange} /> <label
                                                                htmlFor="mfaswitch" className="toggle">
                                                                <p></p>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {(role <= 1) && <div className="innerboxwidth">
                                                    <div className="settingbox">
                                                        <label>E-NRMS Registration Access</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="enrmsRegistrationSwitch" className="checkbox" checked={formData.enrms_registration_switch === true} name="enrms_registration_switch" onChange={handleTnsSwitchChange} /> <label
                                                                htmlFor="enrmsRegistrationSwitch" className="toggle">
                                                                <p></p>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {formData.enrms_registration_switch === true && <div className="settingbox">
                                                        <label>E-NRMS Registration Set up</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="enrmsRegistrationEditSwitch" className="checkbox" checked={formData.enrms_registration_edit_switch === true} name="enrms_registration_edit_switch" onChange={handleTnsSwitchChange} /> <label
                                                                htmlFor="enrmsRegistrationEditSwitch" className="toggle">
                                                                <p></p>
                                                            </label>
                                                        </div>
                                                    </div>}
                                                    {formData.enrms_registration_switch === true && <div className="settingbox">
                                                        <label>E-NRMS Admin Registration Set up</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="enrmsRegistrationAdminSwitch" className="checkbox" checked={formData.enrms_registration_admin_switch === true} name="enrms_registration_admin_switch" onChange={handleTnsSwitchChange} /> <label
                                                                htmlFor="enrmsRegistrationAdminSwitch" className="toggle">
                                                                <p></p>
                                                            </label>
                                                        </div>
                                                    </div>}
                                                </div>}
                                            {role < 2 && parseInt(formData.user_role) <= 2 && <>
                                                    <div className="settingbox">
                                                        <label>Device Management Access</label>
                                                        <div className="selectbox">
                                                            <select
                                                                name="device_management_access"
                                                                value={formData.device_management_access}
                                                                onChange={(e) => setFormData({...formData, device_management_access: parseInt(e.target.value)})}
                                                            >
                                                                <option value={0}>None</option>
                                                                <option value={1}>1-Enable/Disable</option>
                                                                <option value={2}>2-Change Group</option>
                                                                <option value={3}>3-Full</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="settingbox">
                                                        <label>Export User Access</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="export_user_access" className="checkbox" checked={formData.export_user_access === true} name="export_user_access" onChange={handleTnsSwitchChange} /> <label
                                                                htmlFor="export_user_access" className="toggle"><p></p></label>
                                                        </div>
                                                    </div>
                                                    <div className="settingbox">
                                                        <label>View BAP ID</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="view_bap_id_access" className="checkbox" checked={formData.view_bap_id_access === true} name="view_bap_id_access" onChange={handleTnsSwitchChange} /> <label
                                                                htmlFor="view_bap_id_access" className="toggle"><p></p></label>
                                                        </div>
                                                    </div>
                                                </>}
                                        </div>
                                    
                                     {(role <= 1 && formData.user_role == 2) && <div className="common-white-shadow-background setting-section">
                                        <div className="innerboxwidth">
                                            <div className="row">
                                                <h3>Call Pass Permissions</h3>
                                                <div className="settingbox">
                                                    <label>Call Pass - Branded Calling</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_call_pass_branded_calling_switch" className="checkbox" checked={formData.user_call_pass_branded_calling_switch == true} name="user_call_pass_branded_calling_switch" onChange={handleTnsSwitchChange} />
                                                        <label htmlFor="user_call_pass_branded_calling_switch" className="toggle"><p></p></label>
                                                    </div>
                                                </div>
                                                <div className="settingbox">
                                                    <label>Update Customer Call Pass Permissions</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_call_pass_update_customer_permissions_switch" className="checkbox" checked={formData.user_call_pass_update_customer_permissions_switch == true} name="user_call_pass_update_customer_permissions_switch" onChange={handleTnsSwitchChange} />
                                                        <label htmlFor="user_call_pass_update_customer_permissions_switch" className="toggle"><p></p></label>
                                                    </div>
                                                </div>
                                                <div className="settingbox">
                                                    <label>Call Pass Display Identities</label>
                                                    <div className="switchbtn">
                                                        <select
                                                            name="user_call_pass_display_identities_switch"
                                                            value={formData.user_call_pass_display_identities_switch}
                                                            onChange={(e) => setFormData({ ...formData, user_call_pass_display_identities_switch: parseInt(e.target.value) })}
                                                            className="form-control"
                                                        >
                                                            <option value={0}>No Access</option>
                                                            <option value={1}>View Only</option>
                                                            <option value={2}>Edit Access</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="settingbox">
                                                    <label>Export Call Pass</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_call_pass_export_switch" className="checkbox" checked={formData.user_call_pass_export_switch == true} name="user_call_pass_export_switch" onChange={handleTnsSwitchChange} />
                                                        <label htmlFor="user_call_pass_export_switch" className="toggle"><p></p></label>
                                                    </div>
                                                </div>
                                                <div className="settingbox">
                                                    <label>Call Pass Settings</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="callpassaccess" className="checkbox" checked={accessRight.callpassaccess == true} name="callpassaccess" onChange={(e) => setAccessRight(prev => ({ ...prev, callpassaccess: e.target.checked }))} />
                                                        <label htmlFor="callpassaccess" className="toggle"><p></p></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}

                                     {(formData.user_role == '3' || formData.user_role == '4' || formData.user_role == '5' ) && <div className="common-white-shadow-background setting-section">
                                        <div className="innerboxwidth">
                                            <div className="row">
                                                <h3>Settings</h3>
                                                {/* <div className="settingbox">
                                                <label>Cloud PBX Access</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="pbxswitch" className="checkbox"  checked={formData.pbx_switch === true} name="pbx_switch"  onChange={handlePBXSwitchChange} /> <label
                                                            htmlFor="pbxswitch" className="toggle">
                                                            <p>
                                                               
                                                            </p>
                                                        </label>
                                                    </div>
                                                    <div className="daybox">
                                                        {/* {setting.disconnectSwitch && (<label htmlFor="">Days <input type="text" name="disconnectday"
                                                            placeholder="120" value={setting.disconnectday} onChange={handleDayChange} /></label>
                                                        )} 
                                                    </div>
                                                </div> */}
                                                {formData.pbx_switch && <div className="row">
                                                        <div className="col-sm-12">
                                                            <input type="text" name="pbx_url" defaultValue={formData.pbx_url}
                                                              placeholder="PBX cloud url" onChange={handleInputChange}  />
                                                            
                                                        </div>
                                                        {/* <div className="col-sm-6">
                                                            <input type="text" name="pbx_username" defaultValue={formData.pbx_username}
                                                              placeholder="PBX cloud username" onChange={handleInputChange}  />
                                                            
                                                        </div>
                                                        <div className="col-sm-6">
                                                        <input type="password" name="pbx_password" defaultValue={formData.pbx_password}
                                                             placeholder="PBX cloud password" onChange={handleInputChange}  />
                                                            
                                                        </div> */}
                                                    </div>}
                                                
                                                {/* TNS Settings — removed per BBD request
                                                {formData.enable_tns_api==1 && <div className="settingbox">
                                                <label>Enable TNS Access</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="tnsApiAccess" className="checkbox"  checked={formData.tns_api_access === true} name="tns_api_access"  onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="tnsApiAccess" className="toggle">
                                                            <p>

                                                            </p>
                                                        </label>
                                                    </div>
                                                    <div className="daybox">
                                                    </div>
                                                </div>}
                                                */}
                                                {formData.cia_enable_switch == 1 && formData.cia_account_type == 1 && <div className="settingbox">
                                                <label>Enable ENRMS Access</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="enrmsAccessSwitch" className="checkbox"  checked={formData.enrms_access_switch === true} name="enrms_access_switch"  onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="enrmsAccessSwitch" className="toggle">
                                                            <p>

                                                            </p>
                                                        </label>
                                                    </div>

                                                </div>}
                                                <div className="settingbox">
                                                    <label>Enable Number Management Access</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="numberManagementAccessSwitch" className="checkbox"  checked={formData.number_management_access_switch === true} name="number_management_access_switch"  onChange={handleNumberManagementSwitchChange} /> <label
                                                            htmlFor="numberManagementAccessSwitch" className="toggle">
                                                            <p>
                                                               
                                                            </p>
                                                        </label>
                                                    </div>                                                    
                                                </div>
                                                {compAccessList.company_e911_switch == true && <div className="settingbox">
                                                    <label>E911</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_e911_switch" className="checkbox" checked={formData.user_e911_switch === true} name="user_e911_switch" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_e911_switch" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {compAccessList.company_cname_switch == true && <div className="settingbox">
                                                    <label>CNAM</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_cname_switch" className="checkbox"  checked={formData.user_cname_switch === true} name="user_cname_switch" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_cname_switch" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {compAccessList.company_digit_mapping_switch == true && <div className="settingbox">
                                                    <label>Digit Mapping</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_digit_mapping_switch" className="checkbox" checked={formData.user_digit_mapping_switch === true} name="user_digit_mapping_switch" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_digit_mapping_switch" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {compAccessList.company_advance_digit_mapping_switch == true && formData.user_digit_mapping_switch == true && <div className="settingbox">
                                                    <label>Advance Digit Mapping Option</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_advance_digit_mapping_switch" className="checkbox" checked={formData.user_advance_digit_mapping_switch === true} name="user_advance_digit_mapping_switch" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_advance_digit_mapping_switch" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {compAccessList.company_report_switch == true && <div className="settingbox">
                                                    <label>Traffic and Analytics Reporting</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_report_switch" className="checkbox" checked={formData.user_report_switch === true} name="user_report_switch" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_report_switch" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {compAccessList.company_inventory_switch == true && <div className="settingbox">
                                                    <label>Inventory Listing</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_inventory_switch" className="checkbox" checked={formData.user_inventory_switch === true} name="user_inventory_switch" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_inventory_switch" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {compAccessList.company_multiple_inventory_switch == true && <div className="settingbox">
                                                    <label>Mutiple Inventory Edit</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_multiple_inventory_switch" className="checkbox" checked={formData.user_multiple_inventory_switch === true} name="user_multiple_inventory_switch" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_multiple_inventory_switch" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {compAccessList.company_call_pass_branded_calling_swtich >= 1 && <div className="settingbox">
                                                    <label>Call Pass - Branded Calling</label>
                                                    <div className="switchbtn">
                                                        <input
                                                            type="checkbox"
                                                            id="user_call_pass_branded_calling_switch"
                                                            className="checkbox"
                                                            checked={formData.user_call_pass_branded_calling_switch >= 1}
                                                            onChange={(e) => setFormData({...formData, user_call_pass_branded_calling_switch: e.target.checked ? 1 : 0})}
                                                            disabled={parseInt(role) === 2 && !canUpdateCallPassPermissions}
                                                        />
                                                        <label htmlFor="user_call_pass_branded_calling_switch" className="toggle"><p></p></label>
                                                    </div>
                                                </div>}
                                                {compAccessList.company_call_pass_display_identities_switch >= 1 && <div className="settingbox">
                                                    <label>Call Pass Display Identities</label>
                                                    <div className="switchbtn">
                                                        <select
                                                            name="user_call_pass_display_identities_switch"
                                                            value={formData.user_call_pass_display_identities_switch}
                                                            onChange={(e) => setFormData({...formData, user_call_pass_display_identities_switch: parseInt(e.target.value)})}
                                                            className="form-control"
                                                            disabled={parseInt(role) === 2 && !canUpdateCallPassPermissions}
                                                        >
                                                            <option value={0}>No Access</option>
                                                            <option value={1}>View Only</option>
                                                            {compAccessList.company_call_pass_display_identities_switch >= 2 && <option value={2}>Edit Access</option>}
                                                        </select>
                                                    </div>
                                                </div>}
                                                
                                                {compAccessList.company_international_order_switch == true && <div className="settingbox">
                                                    <label>International Order</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_international_order_switch" className="checkbox"  checked={formData.user_international_order_switch === true} name="user_international_order_switch" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_international_order_switch" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {(role < 3) && <div className="settingbox">
                                                    <label>Manage Tags</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="user_manage_tags" className="checkbox"  checked={formData.user_manage_tags === true} name="user_manage_tags" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="user_manage_tags" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>}
                                                {applicationList.length > 0 && applicationList.map((item) => (
                                                        <>
                                                            <div className="settingbox">
                                                                <label>{item.name}</label>
                                                                <div className="switchbtn">
                                                                    <input type="checkbox" id={item.id} className="checkbox"  checked={formData.user_pbx_switch.includes(item.id)} onChange={handlePBXSwitchChange} name={item.id} /> <label
                                                                        htmlFor={item.id} className="toggle">
                                                                        <p>

                                                                        </p>
                                                                    </label>
                                                                </div>

                                                            </div>                                                            
                                                        </>))}

                                                {/* <div className="settingbox">
                                                    <label>Use Customer Trunk in NSS</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="is_nss_trunk_enable" className="checkbox" disabled={(role > 3)} checked={formData.is_nss_trunk_enable === true} name="is_nss_trunk_enable" onChange={handleTnsSwitchChange} /> <label
                                                            htmlFor="is_nss_trunk_enable" className="toggle">
                                                            <p>
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>}
                                    {/*{(formData.user_role == '3' || formData.user_role == '4' ) && <div className="common-white-shadow-background setting-section">
                                        <div className="row">
                                            <div className="col-7">
                                                <h3>Trunks</h3>
                                            </div>
                                            <div className="col-5">
                                                <input className="search-leave satff-listing-page-search" type="text"
                                                    name="search" placeholder="Search" style={{width:'100%'}} />
                                            </div>
                                            <div className="tablebox">
                                                <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                                                    <table>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>TID</th>
                                                            <th colSpan="2">Name</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={trunkData.some((item) => item.name === 'ORG BROADBAND-DYNAMICS_LA1')} onChange={(e) => handleCheckboxChange(e, {name:'ORG BROADBAND-DYNAMICS_LA1', value:45265}, 0)} /></td>
                                                            <td>45265</td>
                                                            <td colSpan="2">ORG BROADBAND-DYNAMICS_LA1</td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={trunkData.some((item) => item.name === 'ORG BROADBAND-DYNAMICS_TOR1')} onChange={(e) => handleCheckboxChange(e, {name:'ORG BROADBAND-DYNAMICS_TOR1',  value:45281}, 0)} /></td>
                                                            <td>45281</td>
                                                            <td colSpan="2">ORG BROADBAND-DYNAMICS_TOR1</td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={trunkData.some((item) => item.name === 'ORG BROADBAND-DYNAMICS_MN1')} onChange={(e) => handleCheckboxChange(e, {name:'ORG BROADBAND-DYNAMICS_MN1',  value:45282}, 0)} /></td>
                                                            <td>45282</td>
                                                            <td colSpan="2">ORG BROADBAND-DYNAMICS_MN1</td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={trunkData.some((item) => item.name === 'ORG BROADBAND-DYNAMICS_SLC1')} onChange={(e) => handleCheckboxChange(e, {name:'ORG BROADBAND-DYNAMICS_SLC1',  value:45283}, 0)} /></td>
                                                            <td>45283</td>
                                                            <td colSpan="2">ORG BROADBAND-DYNAMICS_SLC1</td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={trunkData.some((item) => item.name === 'ORG BROADBAND-DYNAMICS_LA2')} onChange={(e) => handleCheckboxChange(e, {name:'ORG BROADBAND-DYNAMICS_LA2', value:45284}, 0)} /></td>
                                                            <td>45284</td>
                                                            <td colSpan="2">ORG BROADBAND-DYNAMICS_LA2</td>
                                                           
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={trunkData.some((item) => item.name === 'ORG BROADBAND-DYNAMICS_SLC2')} onChange={(e) => handleCheckboxChange(e, {name:'ORG BROADBAND-DYNAMICS_SLC2', value:45554}, 0)} /></td>
                                                            <td>45554</td>
                                                            <td colSpan="2">ORG BROADBAND-DYNAMICS_SLC2</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {(formData.user_role == '3' || formData.user_role == '4') && <div className="common-white-shadow-background setting-section">
                                        <div className="row">
                                            <div className="col-7">
                                                <h3>White Label SBC Trunks <img src={`${process.env.PUBLIC_URL}/images/bx-refresh.png`} style={{background: '#f5f5f5', borderRadius: '2px'}} /></h3>
                                            </div>
                                            <div className="col-5">
                                                <input className="search-leave satff-listing-page-search" type="text"
                                                    name="search" placeholder="Search" style={{width:'100%'}} />
                                            </div>
                                            <div className="tablebox">
                                                <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                                                    <table>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>TID</th>
                                                            <th colSpan="2">Name</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={whiteLabelData.some((item) => item.name === 'LA2_BBD_9644_DID')} onChange={(e) => handleCheckboxChange(e, {name:'LA2_BBD_9644_DID', value:9644}, 1)}/></td>
                                                            <td>9644</td>
                                                            <td colSpan="2">LA2_BBD_9644_DID</td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={whiteLabelData.some((item) => item.name === 'VOIP_DLR_MIN_LD')} onChange={(e) => handleCheckboxChange(e, {name:'VOIP_DLR_MIN_LD', value:1048}, 1)}/></td>
                                                            <td>1048</td>
                                                            <td colSpan="2">VOIP_DLR_MIN_LD</td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={whiteLabelData.some((item) => item.name === 'MN2_BBD_7012_DID')} onChange={(e) => handleCheckboxChange(e, {name:'MN2_BBD_7012_DID', value:7012}, 1)}/></td>
                                                            <td>7012</td>
                                                            <td colSpan="2">MN2_BBD_7012_DID</td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={whiteLabelData.some((item) => item.name === 'MN2_BBD_9644_DID')} onChange={(e) => handleCheckboxChange(e, {name:'MN2_BBD_9644_DID', value:9644}, 1)}/></td>
                                                            <td>9644</td>
                                                            <td colSpan="2">MN2_BBD_9644_DID</td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={whiteLabelData.some((item) => item.name === 'BBD_9644_DID')} onChange={(e) => handleCheckboxChange(e, {name:'BBD_9644_DID', value:9644}, 1)}/></td>
                                                            <td>9644</td>
                                                            <td>BBD_9644_DID</td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td><input type="checkbox" name="" id="" checked={whiteLabelData.some((item) => item.name === 'MIN_BBD_9644_DID')} onChange={(e) => handleCheckboxChange(e, {name:'MIN_BBD_9644_DID', value:9644}, 1)} /></td>
                                                            <td>9644</td>
                                                            <td colSpan="2">MIN_BBD_9644_DID</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>} */}
                                    <div className="col-12">
                                        <input type="submit" value="Update User" className={buttonDisabled ? 'yellow-button disabled-link' : 'yellow-button'}  />
                                    </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                
            </div>
        </div>
    )
}
 
export default EditUser
